<template>
  <v-card>
    <v-card-title primary-title>
      <h3 class="headline mb-0">Email</h3>
    </v-card-title>

    <v-card-text v-if="showError">
      <v-alert
      v-model="showError"
      type="error"
      icon="warning"
      dismissible>
        {{ errorMessage }}
      </v-alert>
    </v-card-text>

    <v-card-actions v-if="requiresNewLogin">
      <v-btn
      @click="loginWithProvider('google.com')"
      :disabled="isUpdatingUser || !providerGoogleData"
      block
      flat>
        <v-avatar tile size="18px" left>
          <img src="@/assets/google_64.png" alt="Google">
        </v-avatar>
        Relogin with Google
      </v-btn>
    </v-card-actions>
    <v-card-actions v-if="requiresNewLogin">
      <v-btn
      @click="loginWithProvider('facebook.com')"
      :disabled="isUpdatingUser || !providerFacebookData"
      block
      flat>
        <v-avatar tile size="18px" left>
          <img src="@/assets/facebook_64.png" alt="Facebook">
        </v-avatar>
        Relogin with Facebook
      </v-btn>
    </v-card-actions>
    <v-card-actions v-if="requiresNewLogin">
      <v-btn
      @click="loginWithProvider('twitter.com')"
      :disabled="isUpdatingUser || !providerTwitterData"
      block
      flat>
        <v-avatar tile size="18px" left>
          <img src="@/assets/twitter_64.png" alt="Twitter">
        </v-avatar>
        Relogin with Twitter
      </v-btn>
    </v-card-actions>

    <v-card-actions v-if="!providerData && !newData">
      <v-btn
      v-if="!providerData"
      @click="newData = true"
      :disabled="isUpdatingUser"
      block
      flat>
        <v-icon left>email</v-icon>
        Add Email connection
      </v-btn>
    </v-card-actions>

    <v-card-text v-if="providerData && !newData">
      <v-layout row wrap>
        <v-flex xs12 sm2>Name:</v-flex>
        <v-flex xs12 sm10>{{ displayName }}</v-flex>
        <v-flex xs12 sm2>Email:</v-flex>
        <v-flex xs12 sm10>{{ displayEmail }}</v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions v-if="providerData && !newData">
      <v-spacer></v-spacer>
      <v-btn
      @click="removeProvider"
      :disabled="isUpdatingUser"
      flat>
        <v-icon left>email</v-icon>
        Remove Email connection
      </v-btn>
    </v-card-actions>

    <v-card-text v-if="newData && !requiresNewLogin">
      <v-form @submit.prevent="validateRegister">
        <v-text-field
        label="E-mail"
        v-model="email"
        type="email"
        :error-messages="emailErrors"
        @input="$v.email.$touch()"
        @blur="$v.email.$touch()"
        required
        :disabled="isUpdatingUser"
        ></v-text-field>

        <v-text-field
        label="Password"
        v-model="password"
        :type="showPassword ? 'text' : 'password'"
        :error-messages="passwordErrors"
        @input="$v.password.$touch()"
        @blur="$v.password.$touch()"
        required
        hint="At least 8 characters"
        counter
        :append-icon="showPassword ? 'visibility_off' : 'visibility'"
        @click:append="showPassword = !showPassword"
        :disabled="isUpdatingUser"
        ></v-text-field>

        <v-text-field
        label="Repeat password"
        v-model="password2"
        :type="showPassword2 ? 'text' : 'password'"
        :error-messages="password2Errors"
        @input="$v.password2.$touch()"
        @blur="$v.password2.$touch()"
        required
        :append-icon="showPassword2 ? 'visibility_off' : 'visibility'"
        @click:append="showPassword2 = !showPassword2"
        :disabled="isUpdatingUser"
        ></v-text-field>
      </v-form>
    </v-card-text>

    <v-card-actions v-if="newData && !requiresNewLogin">
      <v-spacer></v-spacer>

      <v-btn
      v-if="newData"
      @click="newData = false; this.showError = false; this.showInfo = false;"
      :disabled="isUpdatingUser"
      flat>
        Cancel
      </v-btn>

      <v-btn
      v-if="newData"
      @click="validateAddProvider"
      :disabled="isUpdatingUser"
      flat>
        Confirm
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
// import { firebase, auth } from '@/firebase.js';
// import { /*mapGetters,*/ mapState } from 'vuex';
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('auth')
import { validationMixin } from 'vuelidate';
import {
  required,
  email,
  minLength
  // maxLength
} from 'vuelidate/lib/validators'

export default {
  name: 'ProviderEmailCard',
  mixins: [ validationMixin ],
  data() {
    return {
      debug: false,
      provider: 'password',

      showError: false,
      errorMessage: '',

      newData: false,
      email: '',
      password: '',
      showPassword: false,
      password2: '',
      showPassword2: false,

      requiresNewLogin: false
    }
  },
  props: {},
  validations: {
    name: {},
    email: { required, email },
    password: { required, minLength: minLength(8) },
    password2: { required, minLength: minLength(8) }
  },
  computed: {
    ...mapState({
      user: state => state.user, // map `this.user` to `this.$store.state.users.user`
      isUpdatingUser: state => state.isUpdatingUser, // map `this.user` to `this.$store.state.users.isUpdatingUser`
    }),

    providerData() {
      if (!this.user || !this.user.providerData || !this.user.providerData.find) return false;
      let found = this.user.providerData.find((provider) => {
        return provider.providerId && provider.providerId === 'password';
      });
      return found;
    },
    providerGoogleData() {
      if (!this.user || !this.user.providerData || !this.user.providerData.find) return false;
      let found = this.user.providerData.find((provider) => {
        return provider.providerId && provider.providerId === 'google.com';
      });
      return found;
    },
    providerFacebookData() {
      if (!this.user || !this.user.providerData || !this.user.providerData.find) return false;
      let found = this.user.providerData.find((provider) => {
        return provider.providerId && provider.providerId === 'facebook.com';
      });
      return found;
    },
    providerTwitterData() {
      if (!this.user || !this.user.providerData || !this.user.providerData.find) return false;
      let found = this.user.providerData.find((provider) => {
        return provider.providerId && provider.providerId === 'twitter.com';
      });
      return found;
    },
    displayName() {
      return (this.providerData && this.providerData.displayName ? this.providerData.displayName : '');
    },
    displayEmail() {
      return (this.providerData && this.providerData.email ? this.providerData.email : '');
    },
    emailErrors() {
      const errors = [];
      if (this.$v.email.$dirty) {
        !this.$v.email.email && errors.push('Must be valid e-mail');
        !this.$v.email.required && errors.push('E-mail is required');
      }
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (this.$v.password.$dirty) {
        !this.$v.password.minLength && errors.push('Password must be at least 8 characters long');
        !this.$v.password.required && errors.push('Password is required');
      }
      return errors
    },
    password2Errors() {
      const errors = [];
      this.password !== this.password2 && errors.push('Passwords are different');
      return errors;
    }
  },

  methods: {
    ...mapActions([
      'addUserProvider', // map `this.addUserProvider(providerName)` to `this.$store.dispatch('users/addUserProvider', providerName)`
      'removeUserProvider', // map `this.removeUserProvider(providerName)` to `this.$store.dispatch('users/removeUserProvider', providerName)`
      'loginUserWithProvider' // map `this.loginUserWithProvider(providerName)` to `this.$store.dispatch('users/loginUserWithProvider', providerName)`
    ]),

    clearForm() {
      this.$v.$reset();
      this.email = null;
      this.password = null;
      this.password2 = null;
    },

    validateAddProvider() {
      if (this.debug) console.log(this.$options.name+'.validateAddProvider()');
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.addProvider()
      }
    },

    addProvider() {
      if (this.debug) console.log(this.$options.name+'.addProvider()');
      this.addUserProvider('password', { email: this.email, password: this.password })
      .then(() => {
        if (this.debug) console.log(this.$options.name+'.addProvider() provider added');
        this.showError = false;
        this.newData = false;
        this.requiresNewLogin = false;
      })
      .catch((error) => {
        if (this.debug) console.log(this.$options.name+'.addProvider() error:',error);
        if (error.code === 'auth/requires-recent-login') this.requiresNewLogin = true
        if (error.message) this.errorMessage = error.message
        else this.errorMessage = error
        this.showError = true
      })
    },

    removeProvider() {
      if (this.debug) console.log(this.$options.name+'.removeProvider()');
      this.removeUserProvider('password')
      .then(() => {
        if (this.debug) console.log(this.$options.name+'.removeProvider() provider removed');
        this.showError = false;
      })
      .catch((error) => {
        if (this.debug) console.log(this.$options.name+'.removeProvider() error:',error);
        if (error.message) this.errorMessage = error.message
        else this.errorMessage = error
        this.showError = true
      })
    },

    loginWithProvider(providerName) {
      if (this.debug) console.log(this.$options.name+'.loginWithProvider()');
      this.loginUserWithProvider(providerName)
      .then(() => {
        if (this.debug) console.log(this.$options.name+'.loginWithProvider() provider removed');
        this.showError = false;
        this.requiresNewLogin = false;
      })
      .catch((error) => {
        if (this.debug) console.log(this.$options.name+'.loginWithProvider() error:',error);
        if (error.message) this.errorMessage = error.message
        else this.errorMessage = error
        this.showError = true
      })
    }

  }
}
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
.v-avatar[left] {
  margin-right: 16px;
}
</style>